import { createApp, h } from 'vue';
import { WidgetStandard } from '@/components/widgets/standard';
import '@/styles/widgets.global.scss';
import { Store } from 'vuex';
import { CoreService, ServiceContainer } from '@/services';
import { PpSourceType } from '@/types/core';

export class Widgets {
	store: Store<void>

	coreService: CoreService

	services: ServiceContainer

	constructor(store: Store<void>, services: ServiceContainer) {
		this.store = store;
		this.coreService = services.core;
		this.services = services;
	}

	init(): void {
		this.initWidgets();
		this.watchDOMChanges();
	}

	private initWidgets(): void {
		const widgetInitializedSelector = '.pp-widget-initialized';
		const widgetSelector = '.pp2-widget';
		const buttons = document.querySelectorAll(`${widgetSelector}:not(${widgetInitializedSelector})`) as NodeListOf<HTMLElement>;
		const isVDP = Array.from([...new Set(Array.from(buttons).map(widget => widget.dataset.vin))]).length < 2;

		buttons.forEach(el => {
			const vin: string = el.getAttribute('data-vin') ? el.getAttribute('data-vin') as string : ''; // required
			const vdpUrl: string = el.getAttribute('data-vdp-url') ? el.getAttribute('data-vdp-url') as string : ''; // required
			const { cssText } = el.style;
			const { className } = el;

			const custom: string = el.innerHTML;
			const type: string = el.getAttribute('data-type') ? el.getAttribute('data-type') as string : 'standard'; // optional
			const vehicleImageUrl = el.getAttribute('data-vehicle-image-url') ? el.getAttribute('data-vehicle-image-url') as string : ''; // optional
			const entryPoint = el.getAttribute('data-entry-point') ? el.getAttribute('data-entry-point') as string : 'standard'; // optional

			// TODO: Adapt other props and widgets
			// const paymentTermsString = el.getAttribute('data-payment-terms');
			const sourceTypeData: string | undefined = el.getAttribute('data-source')?.toLowerCase();
			//
			let sourceType: PpSourceType = 'not-provided';
			// let paymentTerms: PaymentTerms = {};
			//
			// if (paymentTermsString) {
			//   try {
			//     paymentTerms = JSON.parse(paymentTermsString);
			//   } catch (error) {
			//     console.error('Wrong payment terms');
			//   }
			// }

			if (sourceTypeData && ['vdp', 'srp'].indexOf(sourceTypeData) !== -1) {
				sourceType = sourceTypeData as PpSourceType;
			} else {
				sourceType = this.identifySource(vin, vdpUrl);
			}

			let widget = WidgetStandard;

			switch (type) {
				// case 'button':
				//   widget = WidgetMonthly;
				//   break;
				// case 'slider':
				//   widget = WidgetSlider;
				//   break;
				case 'standard':
				default:
					widget = WidgetStandard;
					break;
			}

			const mountPoint = document.createElement('div');

			createApp({
				render: () => h(widget, {
					vin,
					vdpUrl,
					vehicleImageUrl,
					entryPoint,
					custom,
					style: cssText,
					isVDP,
					sourceType,
					// precisePrice,
					// paymentTerms,
					class: className,
				}),
			})
				.provide('coreModule', this.store.coreModule)
				.provide('coreService', this.coreService)
				.provide('serviceContainer', this.services)
				.provide('writeupModule', this.store.writeupModule)
				.provide('cbcModule', this.store.cbcModule)
				.mount(mountPoint);

			el.replaceWith(...mountPoint.childNodes);
		});
	}

	private watchDOMChanges(): void {
		new MutationObserver(() => {
			this.initWidgets();
		})
			.observe(window.document.documentElement, {
				childList: true,
				subtree: true,
			});
	}

	/**
	 * Trying to identify source from vdp url and number of widgets with different vin on the page
	 * @param {string} vin
	 * @param {string} vdpUrl
	 */
	public identifySource(vin: string, vdpUrl: string): PpSourceType {
		let source: PpSourceType = 'not-provided';

		if (vdpUrl) {
			// Use vdp url to identify source
			const currentUrl = window.location.href;

			source = currentUrl === vdpUrl ? 'vdp' : 'srp';
		} else {
			// Use number of widgets with current vin on the page
			// query .pp-widget:not([data-vin="vin"]).length
			const widgets = document.querySelectorAll(`.pp2-widget:not([data-vin='${vin}'])`);

			source = widgets.length > 1 ? 'srp' : 'vdp';
		}
		return source;
	}
}
